import { serviceCreatePet, serviceGetPet, serviceUpdatePet } from "../services/Pet.service";
import EventEmitter from "../libs/Events.utils";
import store from "../store";
import constants from "../config/constants";


export const FETCH_INIT = 'FETCH_INIT_PET';
export const FETCHED = 'FETCHED_PET';
export const FETCHED_FAIL = 'FETCHED_FAIL_PET';
export const FETCHED_FILTER = 'FETCHED_FILTER_PET';
export const FETCH_NEXT = 'FETCH_NEXT_PET';
export const FILTER = 'FILTER_PET';
export const RESET_FILTER = 'RESET_FILTER_PET';
export const SET_SORTING = 'SET_SORTING_PET';
export const SET_FILTER = 'SET_FILTER_PET';
export const SET_PAGE = 'SET_PAGE_PET';
export const CHANGE_PAGE = 'CHANGE_PAGE_PET';
export const CHANGE_STATUS = 'CHANGE_STATE_PET';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_PET';

export const CREATE_DATA = 'CREATE_PET';
export const UPDATE_DATA = 'UPDATE_PET';
export const DELETE_ITEM = 'DELETE_PET';

export function actionFetchPets(index = 1, sorting = {}, filter = {}, shouldReset = false) {
    const request = serviceGetPet({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}

export function actionCreatePets(data) {
    const request = serviceCreatePet(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: 'Saved', type: 'success' });
                dispatch({ type: CREATE_DATA, payload: data.data })
            } else {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: data.message, type: 'error' });
            }
        })
    }
}

export function actionUpdatePets(data) {
    const request = serviceUpdatePet(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: 'Edited Successfully', type: 'success' });
                dispatch({ type: UPDATE_DATA, payload: data.data })
            } else {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, { error: data.error, type: 'error' });
            }
        })
    }
}

export function actionDeletePets(id) {
    const request = serviceGetPet({ id: id });
    return (dispatch) => {
        dispatch({ type: DELETE_ITEM, payload: id })
    }
}



export function actionChangePagePets(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page })
    }
}


export function actionFilterPets(value) {
    const request = null;
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: FILTER, payload: data });
            dispatch({ type: FETCHED, payload: null });
        });
    };
}


export function actionChangeStatusPets(id, status) {
    return (dispatch) => {
        dispatch({ type: CHANGE_STATUS, payload: { id, status } });
    };
}

export function actionResetFilterPets() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPagePets(page) {
    const stateData = store.getState().Pets;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchPets(serverPage + 1, sortingData, { query, query_data: queryData }));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}

